import { useState } from 'react'
import { ContentfulMarkdown } from '@utils/contentful/ContentfulMarkdown'
import { TransparencyPopup } from './Popup'
import cn from 'classnames'
import { ITransparencyItem } from './Transparency.types'
import { ContentfulNextJsImage } from '@components/common/ContentfulImage'
import { Link } from '@noissue-ui-kit/oldBranding/link'

interface ITransparencyBlock {
  headingClassName: string
  transparency: ITransparencyItem
}

export function TransparencyBlock({
  headingClassName,
  transparency,
}: ITransparencyBlock) {
  const [openPopup, setOpenPopup] = useState(false)

  return (
    <div className="relative w-full px-0 pb-20 md:w-4/12 md:pb-48 md:pl-3 md:pr-10 lg:px-10">
      <div className="absolute inline-block -top-0 max-w-[100px] md:static md:mb-1 w-full md:max-w-none">
        <div className="w-10/12 lg:w-auto">
          <ContentfulNextJsImage
            alt={transparency.mainImage?.imageTitle}
            src={transparency.mainImage?.imageUrl}
            layout="responsive"
            width={83}
            height={83} // FIXME: No image optimized?
          />
        </div>
      </div>
      <div>
        <h4
          className={cn(
            'text-2xl font-bold mt-5 mb-14 pl-[100px] pt-[14px] text-[25px] md:p-0 md:mb-8 min-h-[80px] md:min-h-[60px]',
            headingClassName
          )}
        >
          {transparency.heading}
          <span className="block w-full mt-2 mb-6 text-2xl font-normal text-content-base">
            {transparency.subHeading}
          </span>
        </h4>
        <div className="mt-5">
          <ContentfulMarkdown
            overrideStyles={{
              p: ({ children, index }) => (
                <p
                  className={cn('text-primary-text mb-10 text-xl md:block', {
                    hidden: index !== 1,
                  })}
                >
                  {children}
                </p>
              ),
              h3: ({ children }) => (
                <h5 className="hidden mb-1 text-xl font-bold text-acai md:block first:block">
                  {children}
                </h5>
              ),
            }}
          >
            {transparency.descriptions}
          </ContentfulMarkdown>
          <Link
            size="m"
            className="inline-block text-lg font-normal md:hidden"
            iconName="HiArrowRight"
            iconSide="right"
            onClick={() => setOpenPopup(true)}
          >
            {transparency.ctaLabel}
          </Link>
          <div className="absolute justify-center hidden w-full m-auto text-center -bottom-0 -left-0 -right-0 md:flex">
            <ContentfulNextJsImage
              alt={transparency.badgeImage?.imageTitle}
              src={transparency.badgeImage?.imageUrl}
              className="m-auto"
              width={100}
              height={100} // FIXME: No image optimized?
            />
          </div>
        </div>
      </div>
      <TransparencyPopup
        open={openPopup}
        headingClassName={headingClassName}
        transparency={transparency}
        onClose={() => setOpenPopup(false)}
      />
    </div>
  )
}
